import { combineReducers } from 'redux';

/**
 * NOTE: These imports DO NOT go through the index.js for each entity
 *
 *       THIS IS INTENTIONAL!
 *
 *       The reducers ARE NOT a public API unlike actions and selectors which
 *       ARE appropriate to import in components.
 */
/* eslint-disable no-restricted-imports */
import account from 'next/entities/account/reducer';
import features from 'next/entities/features/reducer';
import flows from 'next/entities/flows/reducer';
import user from 'next/entities/user/reducer';
/* eslint-enable no-restricted-imports */

export default combineReducers({
  account,
  features,
  flows,
  user,
});
